// extracted by mini-css-extract-plugin
export var active = "_n0-2";
export var recordingDot = "_n0-1";
export var recordingIndicator = "_n0-0";